import { useMemo } from 'react';
import { useAnalyticsCore, type AnalyticsAdapter } from '@pantry/shared-react/hooks';
import { posthog, isPostHogAvailable } from '@/lib/posthog';

/**
 * Hook for tracking analytics events.
 *
 * Example:
 *   const { track, identify, reset } = useAnalytics();
 *   track(AnalyticsEvents.ITEM_ADDED, { product_id: '123' });
 */
export function useAnalytics() {
  const adapter = useMemo<AnalyticsAdapter>(
    () => ({
      capture: (event, properties) => {
        if (isPostHogAvailable()) posthog.capture(event, properties);
      },
      identify: (userId, properties) => {
        if (isPostHogAvailable()) posthog.identify(userId, properties);
      },
      reset: () => {
        if (isPostHogAvailable()) posthog.reset();
      },
    }),
    []
  );
  return useAnalyticsCore(adapter);
}
